import React, { useState } from "react";
import BackDrop from "../../../components/ui/BackDrop";

import { closeIcon, fileUploadIcon } from "../../../assetData/icons";

const MasterPriceImport = ({ setIsImport, handleImportScript }) => {
  const [selectedFile, setSelectedFile] = useState(null);
  const [isLoading, setIsLoading] = useState(false);

  const onClose = () => {
    setIsImport(false);
  };

  const handleFileChange = (e) => {
    setSelectedFile(e.target.files[0]);
  };

  const handleFileUpload = async () => {
    if (selectedFile) {
      const formData = new FormData();
      formData.append("file", selectedFile);
      setIsLoading(true);

      const res = await handleImportScript(formData);

      if (res.status_code === 200) {
        setIsLoading(false);
      }
    }
  };

  return (
    <>
      <div className="fixed left-1/2 top-1/2 z-50 mx-auto min-h-[300px] w-[500px] max-w-[1200px] -translate-x-1/2 -translate-y-1/2 rounded bg-white p-8">
        <h2 className="pb-4 text-center text-2xl font-bold text-neutral-800">
          Import Scrip
        </h2>

        <button
          type="button"
          className="absolute right-8 top-8"
          onClick={onClose}
        >
          <img src={closeIcon} />
        </button>

        <div className="mt-8 flex gap-2 ">
          <div className="w-full space-y-4">
            <div className="relative overflow-hidden rounded-lg">
              <input
                type="file"
                className="custom-doc-uploader text-neutral-600"
                onChange={handleFileChange}
              />
              <img
                src={fileUploadIcon}
                className="absolute left-4 top-1/2 z-10 -translate-y-1/2"
              />
            </div>

            <button
              className="w-full rounded-lg border-[1px] border-[#25A86A] py-2 font-bold text-[#25A86A]"
              onClick={handleFileUpload}
            >
              Import
            </button>

            {isLoading && <div>Importing...</div>}
          </div>
        </div>
      </div>
      <BackDrop
      //  closeHandler={closeHandler}
      />
    </>
  );
};

export default MasterPriceImport;
